import slugify from 'slugify';

export default {
  props: ['selectedValue', 'option', 'diagonalStrike', 'isBisForm'],
  delimiters: ['#{', '}'],
  data: function () {
    return {}
  },

  methods: {
    slugify: slugify,
    show(value) {
      return this.isBisForm ? !value.available : true;
    },
    disable(value) {
      return this.isBisForm ? false : !value.available
    },
    classForValue(value) {
      const strike = this.isBisForm ? false : !value.available;
      return [
        (value.available ? 'cursor-pointer product-variant-select' : ''),
        (strike ? (this.diagonalStrike ? 'diagonal-strikethrough' : 'strikethrough' ) : ''),
        (this.selectedValue === value.label ? 'faux-underline': '')
      ].join(' ')
    }
  },
  template: `
    <div class="flex -ml-2 -mt-2">
      <div v-if="show(valueObj)"" class="pl-2 pt-2" v-for="valueObj in option.values">
        <input type="radio"
          :disabled="disable(valueObj)"
          @change="$emit('change', option, valueObj.label)"
          :id="$id('option' + option.position + '-' + slugify(valueObj.label))"
          :name="$id('option' + option.position + '-' + slugify(valueObj.label))"
          :value="valueObj.label"
          :checked="selectedValue === valueObj.label"
          class="hidden">

        <label
          class="enlarge-tap"
          :for="$id('option' + option.position + '-' + slugify(valueObj.label))"
          >
          <span :class="classForValue(valueObj)">#{valueObj.label}</span>
        </label>
      </div>
    </div>
  `
}
